import { lazy } from 'react';

export enum SendHandler {
	ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL = 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL',
	RESULT_AFTER_SINGLE_CALL = 'RESULT_AFTER_SINGLE_CALL',
	EXTERNAL_PANEL = 'EXTERNAL_PANEL',
	EXTERNAL_WINDOW = 'EXTERNAL_WINDOW',
	EXTERNAL_REDIRECT_NEWTAB = 'EXTERNAL_REDIRECT_NEWTAB',
	TEXT_HTML = 'TEXT_HTML',
	NATIVE_APP = 'NATIVE_APP',
	TWO_FACTOR_AUTH = 'TWO_FACTOR_AUTH',
	INTERNAL_PANEL = 'INTERNAL_PANEL',
	INTERNAL_HIDDEN_IFRAME = 'INTERNAL_HIDDEN_IFRAME',
	INTERNAL_HIDDEN_IFRAME_POST_MESSAGE = 'INTERNAL_HIDDEN_IFRAME_POST_MESSAGE'
}

export enum ExecuteError {
	ERROR_SCREEN = 'ERROR_SCREEN',
	LUGAS_AMOUNTS_BANNER = 'LUGAS_AMOUNTS_BANNER'
}

export const executeDepositViews = {
	[SendHandler.ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL]: lazy(
		() => import('~/components/payment-beta/components/execute/result-after-single-call')
	),
	[SendHandler.RESULT_AFTER_SINGLE_CALL]: lazy(
		() => import('~/components/payment-beta/components/execute/result-after-single-call')
	),
	[SendHandler.EXTERNAL_PANEL]: lazy(() => import('~/components/payment-beta/components/execute/external-panel')),
	[SendHandler.EXTERNAL_WINDOW]: lazy(() => import('~/components/payment-beta/components/execute/external-window')),
	[SendHandler.EXTERNAL_REDIRECT_NEWTAB]: lazy(
		() => import('~/components/payment-beta/components/execute/external-redirect-newtab')
	),
	[SendHandler.TEXT_HTML]: lazy(() => import('~/components/payment-beta/components/execute/text-html')),
	[SendHandler.NATIVE_APP]: lazy(() => import('~/components/payment-beta/components/execute/native-app')),
	[SendHandler.TWO_FACTOR_AUTH]: lazy(() => import('~/components/payment-beta/components/execute/two-factor')),
	[SendHandler.INTERNAL_PANEL]: lazy(() => import('~/components/payment-beta/components/execute/internal-panel')),
	[SendHandler.INTERNAL_HIDDEN_IFRAME]: lazy(
		() => import('~/components/payment-beta/components/execute/internal-hidden-iframe')
	),
	[SendHandler.INTERNAL_HIDDEN_IFRAME_POST_MESSAGE]: lazy(
		() => import('~/components/payment-beta/components/execute/internal-hidden-iframe')
	),
	[ExecuteError.ERROR_SCREEN]: lazy(() => import('~/components/payment-beta/components/execute/error-screen')),
	[ExecuteError.LUGAS_AMOUNTS_BANNER]: lazy(
		() => import('~/components/payment-beta/components/execute/lugas-amounts-banner')
	)
};
